<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center text-muted" style="margin:30px;">
                    <small>
                        © 2023 {{getFooterText }}| Tüm hakları saklıdır.<br>
                        <a href="http://www.izometri.com.tr">İzometri Bilişim</a> hizmetidir.
                    </small>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        
        getFooterText(){
            var hideFooterInfo = window.settings.customization?.hideFooterInfo ? true : false;
            if(hideFooterInfo)
                return "";
            else
                return "izonay.com ";
        }
    },
}  
</script>
<style scoped>
    .container, .row, .col-md-12, .text-center, .text-muted, small{
        position: relative !important;
        z-index: -1 !important;
    }
</style>